
import VButton from '~/components/ui/VButton'
import VTooltip from '~/components/ui/VTooltip'
import VFormGroup from '~/components/ui/VFormGroup'
import Container from '~/components/layout/Container'
import CoworkingService from '~/components/coworking/CoworkingService'
import { COWORKING_SERVICES } from '~/constants/api'
import { mapGetters, mapState } from 'vuex'

export default {
    async asyncData({ $axios }) {
        const services = await $axios.get(COWORKING_SERVICES)
        return {
            items: services.data.items
        }
    },
    data() {
        return {
            search: '',
            items: [],
        }
    },
    computed: {
        ...mapState('profile', [
            'isAuthorized'
        ]),
        ...mapGetters('profile', [
            'role'
        ]),
        foundItems() {
            return this.items.filter(el => el.name.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()))
        }
    },
    methods: {
        joinUs() {
            if (this.isAuthorized) {
                this.$router.push({
                    name: 'coworking-services'
                })
            } else {
                this.$router.push({
                    name: 'sign-up'
                })
            }
        }
    },
    components: {
        VButton,
        VTooltip,
        Container,
        VFormGroup,
        CoworkingService
    }
}
